<template>
	<c-dialog ref="dialog" title="任务派工" height="600" enable-flex @resolve="submitHandle">
		<div class="total flex-around-center">
			<div class="item flex-column flex-center">
				<div class="num">{{planCount}}</div>
				<p>任务计划数</p>
			</div>
			<div class="item flex-column flex-center">
				<div class="num">{{fineCount}}</div>
				<p>良品数</p>
			</div>
			<div class="item flex-column flex-center">
				<div class="num" :style="{'color': allotCount > planCount ? '#f55' : ''}">{{allotCount}}</div>
				<div class="flex-center">
					<p>总分配数</p>
					<c-tooltip tip="预计总分配的合计"></c-tooltip>
				</div>
			</div>
		</div>
		
		<m-search ref="search" column="2" @search="searchHandle">
			<m-search-item label="生产人员">
				<c-input name="keyword"></c-input>
			</m-search-item>
			<m-search-item>
				<c-checkbox-group name="output_auth" :options="[{name: '有报工权限', value: 1}]" ></c-checkbox-group>
			</m-search-item>

			<template #button>
				<c-button color="main" size="search" @click="$refs.search.search()">查询</c-button>
				<c-button size="search" @click="$refs.search.clear(); $refs.search.search()">加载所有人员</c-button>
			</template>
		</m-search>
		
		<c-table ref="table" :data="tableData" height="grow" :paging="false" @dataChange="updateAllotCount">
			<c-table-column
				type="selector"
				name="selected"
				width="32"
			></c-table-column>

			<c-table-column
				label="生产人员"
				name="user_realname"
			></c-table-column>

			<c-table-column
				label="良品数"
				name="fine_count"
			></c-table-column>

			<c-table-column
				label="已分配数"
				name="qty"
			></c-table-column>

			<c-table-column
				label="本次分配数"
			>
				<template #default="{data}">
					<c-input v-model="data.count" type="stepper" :range="[-data.qty, 99999999]" @change="changeCount(data)" ></c-input>
				</template>
			</c-table-column>

			<c-table-column
				label="预计总分配"
			>
				<template #default="{data}">
					<span>{{(parseInt(data.qty) || 0) + (parseInt(data.count) || 0)}}</span>
				</template>
			</c-table-column>
		</c-table>
	</c-dialog>
</template>

<script>
	export default {
		name: 'taskAllot',

		props: {
			isStatic: Boolean
		},

		data() {
			return {
				planCount: 0,
				fineCount: 0,
				tableData: [],
				allotCount: 0
			}
		},
		
		methods: {
			open(data) {
				this._select_distribute_list = data.distribute_list;
				this._taskId = data.id;
				this._processId = data.process_id;
				this.planCount = parseInt(data.plan_count) || 0;
				this.fineCount = parseInt(data.fine_count) || 0;
				this.tableData = [];
				this.$refs.search.clear();
				this.$refs.search.set({output_auth:[1]});
				this.searchHandle();
				this.$refs.dialog.open();
			},

			/********搜索************/
			searchHandle(data){
				if (!data){
					data = {};
					data.output_auth = 1;
				}else{
					if(data.output_auth.length == 1){
						data.output_auth = 1;
					}else{
						data.output_auth = 2;
					}
				}
				data.task_id = this._taskId;
				data.process_id = this._processId;
				this.request({
					url: '/task/distribute/list',
					data: data,
					loading: true,
					success: data => {
						
						if(this._select_distribute_list){
							data.forEach(item => {
								item.count = 0;
								this._select_distribute_list.forEach(se => {
									if(item.user_id == se.user_id){
										item.selected = true;
									}
								});
							})
						}else{
							data.forEach(item => {
								item.count = 0;
								item.selected = item.id;
							})
						}
						this.tableData = data;
					}
				})
				
			},
			
			/**************变更不良品数量******************/
			changeCount(rowData){
				if (rowData.count > 0 || rowData.qty > 0 || rowData.id){
					rowData.selected = true;
				}else{
					rowData.selected = false;
				}
			},

			updateAllotCount(data) {
				let count = 0;
				data.forEach(item => {
					if (item.selected) {
						count += (parseInt(item.qty) || 0) + (parseInt(item.count) || 0);
					}
				});
				this.allotCount = count;
			},
			
			submitHandle(stop, next) {
				stop();
				let data = this.$refs.table.getData('selected');
				//.filter(item => ((parseInt(item.qty) || 0) + (parseInt(item.count) || 0)) > 0);
				// if (!data.length) {
				// 	this.$message({
				// 		message: '请选择生产人员'
				// 	});
				// 	return;
				// }

				if (this.allotCount > this.planCount) {
					this.$message({
						message: '总分配数不能大于任务计划数'
					});
					return;
				}
				
				//分配列表
				let distribute_list = data.map(item => {
					return {
						user_id: item.user_id,
						user_realname: item.user_realname,
						qty: (parseInt(item.qty) || 0) + (parseInt(item.count) || 0)
					}
				});
				
				//静态不做保存，只返回数据
				if(this.isStatic){
					next();
					this.$emit('resolve', distribute_list);
				}else{
					this.request({
						url: '/task/distribute/edit',
						data: {
							task_id: this._taskId,
							distribute_list: distribute_list
						},
						loading: true,
						success: () => {
							this.$message({
								message: '保存成功'
							});
							next();
							this.$emit('resolve');
						}
					})
				}
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.total {
		padding: 20px 0;
		margin: 10px 10px 0;
		background: #F5F5F5;
		
		.item {
			height: 60px;
			
			.num {
				margin-bottom: 10px;
				font-size: 20px;
				font-weight: bold;

				^[-1]:nth-child(2) ^[-1..-1] {
					color: var(--color-main);
				}
			}

			p {
				font-size: 13px;
				color: #666;

				&:nth-last-child(2) {
					margin-right: 5px;
				}
			}
		}
	}
</style>